import { setSpamListFailed, setSpamListPending, setSpamListSucceed } from './actions';
import { ISpamListRequest } from './types';
import { transformItemListChatV1 } from '../../mappers/transformItemListChatV1';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchSpamChats } from '../../services/chatsList';
import { TChatInListSchema, CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
// eslint-disable-next-line import/no-cycle
import { setRoute } from '../route';
import { getSpamChatsV2 } from './getSpamChatsV2';
import { isChatsV2Enabled } from '../../utils/isChatsV2Enabled';

/**
 * Получить список заблокированных чатов
 */
export const getSpamChats =
  ({ timestampSpam }: ISpamListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const isChatsV2 = isChatsV2Enabled(context.config);

    if (isChatsV2) {
      dispatch(getSpamChatsV2({ timestampSpam }));

      return;
    }

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setSpamListPending({ timestampSpam }));

    const spamChats = await fetchSpamChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestampSpam,
        subAgentRealtyUserId,
      },
    });

    if (spamChats === null) {
      dispatch(setSpamListFailed());

      return;
    }

    // FIXME: хз, что здесь происходит
    const spamChatsVisible = chatList.chats.filter((chat: TChatInListSchema) => chat.blocked).length + spamChats.length;
    const chats = spamChatsVisible ? spamChats.map(transformItemListChatV1) : [];

    dispatch(setSpamListSucceed({ chats }));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(setRoute({ route: ERoute.Spam, cleanRemovedFromSpamChatId: true, cleanRemovedFromArchiveChatId: true }));
  };
